export default __webpack_public_path__ + "static/media/eu.6dd98b24.svg";